import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { CButton, CRow, CCol, CFormLabel, CFormInput, CTable, CTableHead, CTableRow, CTableHeaderCell, CTableBody, CTableDataCell, CFormTextarea } from '@coreui/react';
import toast from 'react-hot-toast';
import { toastConfig } from '../../constants/other.config';
import { Trash2 } from 'lucide-react';
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat';

const AddLabForm = ({ labList, addLabsFn, selectedLabsToEdit, showComment, addedLabs, setAddedLabs, date, setDate, compactMode = false }) => {
    console.log("Lab List", labList, selectedLabsToEdit)



    const [labName, setLabName] = useState('');
    const [value, setValue] = useState('');
    const [unit, setUnit] = useState('');
    const [range, setRange] = useState('');
    const [diagnosis, setDiagnosis] = useState('');
    const [remark, setRemark] = useState('');
    const [localAddedLabs, setLocalAddedLabs] = useState([]);
    const [editLabsIndex, setEditLabsIndex] = useState(null)
    const [comment, setComment] = useState(null)
    const [planRemark, setPlanRemark] = useState('')
    const [exitListData, setExitListData] = useState([])
    const addedLabsData = addedLabs || localAddedLabs;
    const updateAddedLabs = setAddedLabs || setLocalAddedLabs;
    const showDateField = typeof setDate === 'function';

    useEffect(() => {
        if (selectedLabsToEdit) {
            const { data = [] } = selectedLabsToEdit

            updateAddedLabs(data)

            const labNames = data.map((item) => item?.name)

            const filteredLabList = labList?.filter((item) =>
                labNames.includes(item?.LabName)
            ) || []

            setExitListData(filteredLabList)

        } else {

            setLabName('')
            setValue('')
            setUnit('')
            setRange('')
            setDiagnosis('')
            setRemark('')
            setPlanRemark('')
            updateAddedLabs([])
            setExitListData([])
        }
    }, [selectedLabsToEdit, labList])


    console.log("exitListData", exitListData)
    const handleAddLab = () => {
        if (!labName || !value) {
            toast.error('All the fields needs to be filled.', toastConfig)
            return
        }
        if (editLabsIndex !== null) {
            const updatedLabs = [...addedLabsData];
            updatedLabs[editLabsIndex] = {
                name: labName,
                value: value,
                unit: unit,
                range: range,
                diagnosis: diagnosis,
                remark: remark,
                planRemark: planRemark,
                comment: comment
            };
            setComment('')
            updateAddedLabs(updatedLabs);
            addLabsFn(updatedLabs)
            setLabName('');
            setValue('');
            setUnit('');
            setRange('');
            setDiagnosis('');
            setRemark('');
            setEditLabsIndex(null)
            setPlanRemark('')
        } else {
            const newLab = {
                name: labName,
                value: value,
                unit: unit,
                range: range,
                diagnosis: diagnosis,
                remark: remark,
                comment: comment,
                planRemark: planRemark,
            };

            updateAddedLabs([...addedLabsData, newLab]);

            addLabsFn([...addedLabsData, newLab])
            setComment('');
            setLabName('');
            setValue('');
            setUnit('');
            setRange('');
            setDiagnosis('');
            setRemark('');
            setPlanRemark('')
        }
    };

    const handleLabSelectChange = (selectedOption) => {
        const selectedValue = selectedOption?.value || '';
        const selectedLab = (labList || []).find((lab) => lab.LabName === selectedValue);

        setLabName(selectedValue);
        setUnit(selectedLab ? selectedLab.Unit : '');
        setRange(selectedLab ? `${selectedLab.RangeMin} - ${selectedLab.RangeMax}` : '');

        if (!selectedValue) {
            setValue('');
            setDiagnosis('');
            setRemark('');
            setPlanRemark('');
        }
    };


    const handleValueChange = (e) => {
        const value = e.target.value;
        setValue(value);
        const selectedLab = (labList || []).find(lab => lab.LabName === labName);
        if (selectedLab) {
            if (parseFloat(value) < parseFloat(selectedLab.RangeMin)) {
                setDiagnosis(selectedLab.DiagnosesLow);
                setRemark(selectedLab.RemarkLow);
                setPlanRemark(selectedLab.RemarkPlanLow);
            } else if (parseFloat(value) > parseFloat(selectedLab.RangeMax)) {
                setDiagnosis(selectedLab.DiagnosesHigh);
                setRemark(selectedLab.RemarkHigh);
                setPlanRemark(selectedLab.RemarkPlanHigh);
            } else {
                setDiagnosis(selectedLab.DiagnosesNormal || '');
                setRemark(selectedLab.RemarkNormal || '');
                setPlanRemark(selectedLab.RemarkPlanNormal);
            }
        }
    };

    const getValueDerivedFields = (labName, value) => {
        const selectedLab = (labList || []).find(lab => lab.LabName === labName);
        if (!selectedLab) {
            return {};
        }

        if (parseFloat(value) < parseFloat(selectedLab.RangeMin)) {
            return {
                diagnosis: selectedLab.DiagnosesLow,
                remark: selectedLab.RemarkLow,
                planRemark: selectedLab.RemarkPlanLow,
            };
        }

        if (parseFloat(value) > parseFloat(selectedLab.RangeMax)) {
            return {
                diagnosis: selectedLab.DiagnosesHigh,
                remark: selectedLab.RemarkHigh,
                planRemark: selectedLab.RemarkPlanHigh,
            };
        }

        return {
            diagnosis: selectedLab.DiagnosesNormal || '',
            remark: selectedLab.RemarkNormal || '',
            planRemark: selectedLab.RemarkPlanNormal,
        };
    };

    const handleInlineAddedLabChange = (indexToUpdate, field, value) => {
        const updatedLabs = addedLabsData.map((lab, index) => {
            if (index !== indexToUpdate) {
                return lab;
            }

            const updatedLab = {
                ...lab,
                [field]: value,
            };

            if (field === 'value') {
                return {
                    ...updatedLab,
                    ...getValueDerivedFields(lab.name, value),
                };
            }

            return updatedLab;
        });

        updateAddedLabs(updatedLabs);
        addLabsFn(updatedLabs);
    };

    const handleDeleteAddedLabsEntries = (idx) => {
        const filteredLabs = addedLabsData.filter((_, index) => index !== idx);
        addLabsFn(filteredLabs);
        updateAddedLabs(filteredLabs);
    }

    const compactScale = compactMode
        ? {
            fontSize: '0.92rem',
            labelFontSize: '0.92rem',
            inputHeight: '34px',
            buttonMarginTop: '8px',
            tableMinWidth: '1040px',
        }
        : {
            fontSize: '1rem',
            labelFontSize: '1rem',
            inputHeight: '38px',
            buttonMarginTop: '10px',
            tableMinWidth: '100%',
        };
    const availableLabOptions = (labList || [])
        .filter(
            (lab) =>
                !addedLabsData?.some(
                    (added) => added?.name === lab?.LabName
                )
        )
        .map((lab) => ({
            value: lab?.LabName,
            label: lab?.LabName,
        }));
    const selectedLabOption = labName
        ? { value: labName, label: labName }
        : null;
    const selectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: compactScale.inputHeight,
            height: compactScale.inputHeight,
            borderRadius: 8,
            backgroundColor: 'var(--ui-dashboard-surface-2, #1b1b1b)',
            borderColor: state.isFocused ? 'var(--ui-color-primary, #2b7cd3)' : 'var(--ui-dashboard-border-strong, #3a3a3a)',
            boxShadow: state.isFocused ? 'var(--ui-shadow-focus, 0 0 0 2px rgba(43, 124, 211, 0.3))' : 'none',
            fontSize: compactScale.fontSize,
            alignItems: 'center',
            overflow: 'hidden',
            '&:hover': {
                borderColor: 'var(--ui-color-primary, #2b7cd3)',
            },
        }),
        valueContainer: (base) => ({
            ...base,
            alignItems: 'center',
            display: 'flex',
            height: compactScale.inputHeight,
            lineHeight: 1.2,
            overflow: 'visible',
            padding: '0 10px',
        }),
        placeholder: (base) => ({
            ...base,
            color: 'var(--ui-text-placeholder, #94a3b8)',
            lineHeight: 1.2,
            margin: 0,
        }),
        singleValue: (base) => ({
            ...base,
            color: 'var(--ui-text-primary, #ffffff)',
            lineHeight: 1.2,
            margin: 0,
        }),
        input: (base) => ({
            ...base,
            color: 'var(--ui-text-primary, #ffffff)',
            lineHeight: 1.2,
            margin: 0,
            paddingBottom: 0,
            paddingTop: 0,
        }),
        indicatorSeparator: (base) => ({
            ...base,
            backgroundColor: 'var(--ui-dashboard-border-strong, #3a3a3a)',
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: 'var(--ui-text-secondary, #d1d5db)',
            padding: 8,
        }),
        clearIndicator: (base) => ({
            ...base,
            color: 'var(--ui-text-secondary, #d1d5db)',
            padding: 8,
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 2000,
        }),
        menu: (base) => ({
            ...base,
            borderRadius: 8,
            overflow: 'hidden',
            backgroundColor: 'var(--ui-dashboard-surface-2, #1b1b1b)',
            boxShadow: 'var(--ui-shadow-lg, 0 24px 48px rgba(0, 0, 0, 0.34))',
            border: '1px solid var(--ui-dashboard-border-strong, #3a3a3a)',
        }),
        menuList: (base) => ({
            ...base,
            backgroundColor: 'var(--ui-dashboard-surface-2, #1b1b1b)',
            paddingTop: 8,
            paddingBottom: 8,
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
                ? 'var(--ui-color-primary, #2b7cd3)'
                : state.isFocused
                    ? 'var(--ui-bg-hover, #2a2a2a)'
                    : 'var(--ui-dashboard-surface-2, #1b1b1b)',
            color: state.isSelected ? 'var(--ui-text-inverse, #ffffff)' : 'var(--ui-text-primary, #ffffff)',
            fontSize: compactScale.fontSize,
            padding: '12px 16px',
            cursor: 'pointer',
        }),
    };
    const columnWidths = compactMode
        ? {
            labName: '14%',
            value: '12%',
            unit: '13%',
            range: '10%',
            diagnosis: '17%',
            remark: '26%',
            delete: '8%',
        }
        : {
            labName: '9%',
            value: '14%',
            unit: '14%',
            range: '10%',
            diagnosis: '22%',
            remark: '24%',
            delete: '7%',
        };

    const cellStyle = { verticalAlign: 'middle', fontSize: compactScale.fontSize };
    const inlineInputStyle = { minHeight: compactScale.inputHeight, height: compactScale.inputHeight, width: '100%', minWidth: 0, fontSize: compactScale.fontSize };
    const deleteCellStyle = { ...cellStyle, textAlign: 'center', width: '76px' };
    const deleteButtonStyle = {
        alignItems: 'center',
        display: 'inline-flex',
        height: compactScale.inputHeight,
        justifyContent: 'center',
        padding: 0,
        width: compactScale.inputHeight,
    };

    return (
        <div style={compactMode ? { fontSize: compactScale.fontSize } : undefined}>

            <CRow>
                {showDateField && (
                    <CCol md={6}>
                        <CFormLabel style={{ fontSize: compactScale.labelFontSize }}>Date</CFormLabel>
                        <CustomDatePickingFormat
                            value={date}
                            onChange={(e) => setDate(e)}
                            inputStyle={{ minHeight: compactScale.inputHeight, height: compactScale.inputHeight, fontSize: compactScale.fontSize }}
                        />
                    </CCol>
                )}
                <CCol md={showDateField ? 6 : 12}>
                    <CFormLabel style={{ fontSize: compactScale.labelFontSize }}>Lab Name</CFormLabel>

                    <Select
                        value={selectedLabOption}
                        onChange={handleLabSelectChange}
                        options={availableLabOptions}
                        placeholder="Select Lab"
                        isClearable
                        styles={selectStyles}
                        classNamePrefix="patient-lab-select"
                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                    />
                    {showComment && <div className="mb-3">
                        <CFormLabel style={{ fontSize: compactScale.labelFontSize }}>Comment</CFormLabel>
                        <CFormTextarea
                            rows={4}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            style={{ height: compactMode ? '88px' : '100px', fontSize: compactScale.fontSize }}
                        />
                    </div>}
                </CCol>
            </CRow>
            {labName && (
                <CRow className='mt-2'>
                    <CCol md={6}>
                        <CFormLabel style={{ fontSize: compactScale.labelFontSize }}>Value</CFormLabel>
                        <CFormInput type="text" value={value} onChange={handleValueChange} style={compactMode ? { minHeight: compactScale.inputHeight, fontSize: compactScale.fontSize } : undefined} />
                    </CCol>
                    <CCol md={3}>
                        <CFormLabel style={{ fontSize: compactScale.labelFontSize }}>Unit</CFormLabel>
                        <CFormInput type="text" value={unit} onChange={
                            (e) => setUnit(e.target.value)
                        } style={compactMode ? { minHeight: compactScale.inputHeight, fontSize: compactScale.fontSize } : undefined} />
                    </CCol>
                    <CCol md={3}>
                        <CFormLabel style={{ fontSize: compactScale.labelFontSize }}>Range</CFormLabel>
                        <CFormInput type="text" value={range} readOnly style={compactMode ? { minHeight: compactScale.inputHeight, fontSize: compactScale.fontSize } : undefined} />
                    </CCol>
                </CRow>
            )}
            <CButton color="primary" variant="outline" onClick={handleAddLab} style={{ marginTop: compactScale.buttonMarginTop, fontSize: compactScale.fontSize }}>
                {editLabsIndex !== null ? 'Update Labs' : "Add Lab"}
            </CButton>

            <div style={{ marginTop: '20px', overflowX: 'auto', WebkitOverflowScrolling: 'touch', width: '100%' }}>
                <CTable striped hover style={{ tableLayout: 'fixed', width: '100%', minWidth: compactScale.tableMinWidth }}>
                    <CTableHead>
                        <CTableRow>
                            <CTableHeaderCell style={{ width: columnWidths.labName, fontSize: compactScale.fontSize }}>Lab Name</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: columnWidths.value, fontSize: compactScale.fontSize }}>Value</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: columnWidths.unit, fontSize: compactScale.fontSize }}>Unit</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: columnWidths.range, fontSize: compactScale.fontSize }}>Range</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: columnWidths.diagnosis, fontSize: compactScale.fontSize }}>Diagnosis</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: columnWidths.remark, fontSize: compactScale.fontSize }}> Remark</CTableHeaderCell>
                            {/* <CTableHeaderCell>Plan Remark</CTableHeaderCell> */}
                            <CTableHeaderCell style={{ width: columnWidths.delete, textAlign: 'center', fontSize: compactScale.fontSize }}>Delete</CTableHeaderCell>
                        </CTableRow>
                    </CTableHead>
                    <CTableBody>
                        {addedLabsData && addedLabsData.map((lab, index) => (
                            <CTableRow key={index}>
                                <CTableDataCell style={{ ...cellStyle, lineHeight: 1.35, wordBreak: 'break-word' }}>{lab.name}</CTableDataCell>
                                <CTableDataCell style={cellStyle}>
                                    <CFormInput
                                        size="sm"
                                        type="text"
                                        value={lab.value ?? ''}
                                        onChange={(e) => handleInlineAddedLabChange(index, 'value', e.target.value)}
                                        style={inlineInputStyle}
                                    />
                                </CTableDataCell>
                                <CTableDataCell style={cellStyle}>
                                    <CFormInput
                                        size="sm"
                                        type="text"
                                        value={lab.unit ?? ''}
                                        onChange={(e) => handleInlineAddedLabChange(index, 'unit', e.target.value)}
                                        style={inlineInputStyle}
                                    />
                                </CTableDataCell>
                                <CTableDataCell style={{ ...cellStyle, whiteSpace: 'nowrap' }}>{lab.range}</CTableDataCell>
                                <CTableDataCell style={{ ...cellStyle, lineHeight: 1.35, wordBreak: 'break-word' }}>{lab.diagnosis}</CTableDataCell>
                                <CTableDataCell style={{ ...cellStyle, lineHeight: 1.35, wordBreak: 'break-word' }}>{lab.remark}</CTableDataCell>
                                {/* <CTableDataCell>{lab?.planRemark}</CTableDataCell> */}

                                <CTableDataCell style={deleteCellStyle}>
                                    <CButton
                                        variant='outline'
                                        color="danger"
                                        size="sm"
                                        onClick={() => { handleDeleteAddedLabsEntries(index) }}
                                        title="Delete lab"
                                        aria-label={`Delete ${lab.name || 'lab'}`}
                                        style={deleteButtonStyle}
                                    >
                                        <Trash2 size={16} />
                                    </CButton>
                                </CTableDataCell>

                            </CTableRow>
                        ))}
                    </CTableBody>
                </CTable>
            </div>
        </div>
    );
};

export default AddLabForm;
